module.exports = __webpack_public_path__ + "static/media/BlueHira.cb3e1029.png";